import stockAPI from "@/utility/api.js";
import { state } from "@/store/filterRate/state.js";
import { getters } from "@/store/filterRate/getters.js";
import Cookies from "js-cookie";

export const filterRate = {
  state,
  getters,
  mutations: {
    fetchFilterRate(state, res) {
      state.filterRate = res;
    },
    fetchErrorMessage(state, error) {
      state.errorMessage = error || "";
    },
    // mutations 儲存至 state 時，可將數值先進行格式化，防止錯誤數值直送。
    // @change 避免無效空值，當輸入值 parseFloat 轉為 NaN 時，皆需給預設值為 0。
    inputValueOfEBOIC({ ratio }, rate) {
      ratio.EBOIC = rate;
    },
    inputValueOfGrossProfitRatio({ ratio }, rate) {
      ratio.gross_profit_ratio = rate;
    },
    inputValueOfROIC({ ratio }, rate) {
      ratio.ROIC = rate;
    },
    inputValueOfExpectedRateOfReturn({ ratio }, rate) {
      ratio.expected_rate_of_return = rate;
    },
    inputValueOfSelectLevel({ ratio }, level) {
      ratio.level = level;
    },
    companyType({ ratio }, val) {
      ratio.go_public = val;
    },
    stockSymbolInForm({ ratio }, val) {
      ratio.stock_symbol = val;
    },
    selectedStockAtFilterOptions({ filterOptions }, booleanVal) {
      filterOptions.selectStock = booleanVal;
    },
    selectedEBOICAtFilterOptions({ filterOptions }, booleanVal) {
      filterOptions.selectEBOIC = booleanVal;
    },
    selectedROICAtFilterOptions({ filterOptions }, booleanVal) {
      filterOptions.selectROIC = booleanVal;
    },
    selectProfitRatioAtFilterOptions({ filterOptions }, booleanVal) {
      filterOptions.selectProfitRatio = booleanVal;
    }
  },
  actions: {
    // 修改等級資料，直送 api，並無儲存 state。
    async FETCH_UPDATE_LEVEL_WITH_RATE({ dispatch, commit }, submit) {
      try {
        // eslint-disable-next-line no-unused-vars
        const res = await stockAPI.PUT(`/api/update/${submit.stockSymbol}`, {
          api_token: Cookies.get("chuenStock"),
          level: submit.select.includes("-") ? "" : submit.select
        });
        //修改等級後更新 table
        dispatch("updateTableAfterEditLevelOrState");
        // 成功即清除錯誤訊息，回傳預設空值。
        commit("fetchErrorMessage", null);
      } catch ({ message }) {
        // 提示錯誤訊息，優化使用者機制。
        commit("fetchErrorMessage", message);
        console.error(message);
      }
    },
    // 修改狀態(上下市)資料，直送 api，並無儲存 state。
    async FETCH_UPDATE_TYPE_WITH_RATE({ dispatch, commit }, submit) {
      try {
        // eslint-disable-next-line no-unused-vars
        const res = await stockAPI.PUT(`/api/update/${submit.stockSymbol}`, {
          api_token: Cookies.get("chuenStock"),
          go_public: submit.select
        });
        //修改狀態後更新 table
        dispatch("updateTableAfterEditLevelOrState");
        // 成功即清除錯誤訊息，回傳預設空值。
        commit("fetchErrorMessage", null);
      } catch ({ message }) {
        // 提示錯誤訊息，優化使用者機制。
        commit("fetchErrorMessage", message);
        console.error(message);
      }
    },
    async fetchAllCompany({ commit }) {
      try {
        const query = new URLSearchParams({
          level: "All",
          go_public: "All"
        });
        const res = await stockAPI.GET(`/api/filter/rate?${query.toString()}`);
        commit("fetchFilterRate", res);
        // 成功即清除錯誤訊息，回傳預設空值。
        commit("fetchErrorMessage", null);
      } catch ({ message }) {
        // 提示錯誤訊息，優化使用者機制。
        console.log(message);
        commit("fetchErrorMessage", message);
        console.error(message);
      }
    },
    async fetchCompanyByDefault({ commit, state }) {
      try {
        // default：預期投報、等級、狀態
        const { expected_rate_of_return, level, go_public } = state.ratio;
        const query = new URLSearchParams({
          expected_rate_of_return,
          level,
          go_public
        });
        const res = await stockAPI.GET(`/api/filter/rate?${query.toString()}`);
        commit("fetchFilterRate", res);
        // 成功即清除錯誤訊息，回傳預設空值。
        commit("fetchErrorMessage", null);
      } catch ({ message }) {
        console.log(message);
        commit("fetchErrorMessage", message);
        console.error(message);
      }
    },
    async fetchACompanyByStock({ commit, state }) {
      try {
        // 股票代號
        const { stock_symbol } = state.ratio;
        const query = new URLSearchParams({
          stock_symbol
        });
        const res = await stockAPI.GET(`/api/filter/rate?${query.toString()}`);
        commit("fetchFilterRate", res);
        // 成功即清除錯誤訊息，回傳預設空值。
        commit("fetchErrorMessage", null);
      } catch ({ message }) {
        console.log(message);
        commit("fetchErrorMessage", message);
        console.error(message);
      }
    },
    async fetchCompanyBySelectedFilterOptions({ commit }, query) {
      try {
        const res = await stockAPI.GET(`/api/filter/rate?${query}`);
        commit("fetchFilterRate", res);
        // 成功即清除錯誤訊息，回傳預設空值。
        commit("fetchErrorMessage", null);
      } catch ({ message }) {
        console.log(message);
        commit("fetchErrorMessage", message);
        console.error(message);
      }
    },
    updateTableAfterEditLevelOrState({ getters, dispatch }) {
      const queryData = getters.whatQueryDataToGetBySelectedFilterOptions;
      if (!queryData.query) {
        dispatch(queryData.actionName);
      } else {
        dispatch(queryData.actionName, queryData.query);
      }
    }
  }
};
